import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BrowserRouter as Router } from 'react-router-dom';
import ThemeProviderWrapper from './assets/theme';
import store from './state/configureStore';
import './App.css';
import './index.css';
import AppContent from './AppContent';
import { ToastContainer } from 'react-toastify';

const App = () => {

  useEffect(() => {
    // Lazy-load AOS CSS + JS and ReactToastify CSS after first paint (improves LCP)
    import('aos/dist/aos.css');
    import('react-toastify/dist/ReactToastify.css');
    import('aos').then((AOS) => {
      AOS.default.init({ duration: 500 });
    });
  }, []);

  return (
    <Provider store={store}>
      <ThemeProviderWrapper>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Router>
            <AppContent />
          </Router>
        </LocalizationProvider>
      </ThemeProviderWrapper>
      <ToastContainer />
    </Provider>
  );
};

export default App;
